module.exports = __webpack_public_path__ + "7fe981182b842328c37d6667d25635ce.svg";